@if (breadcrumbs() | hasItems) {
  <nz-breadcrumb>
    @for (breadcrumb of breadcrumbsToRender(); track breadcrumb.url) {
      <nz-breadcrumb-item>
        @if (breadcrumb.url && !$last) {
          <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
        } @else {
          <span>{{ breadcrumb.label }}</span>
        }
      </nz-breadcrumb-item>
    }
    @if (customBreadcrumbComponent()) {
      <nz-breadcrumb-item>
        <ng-container [ngTemplateOutlet]="customBreadcrumbComponent()!"></ng-container>
      </nz-breadcrumb-item>
    }
  </nz-breadcrumb>
  @if (customBreadcrumbButtons()) {
    <div class="breadcrumb-buttons">
      <ng-container [ngTemplateOutlet]="customBreadcrumbButtons()!"></ng-container>
    </div>
  }
}
